export default "__VITE_ASSET__CEY2_btq__"